var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"drag",rawName:"v-drag"},{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticStyle:{"width":"400px"},attrs:{"id":"uploader-fixed-wrap"}},[_c('upload',{attrs:{"showList":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }